import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import SnackbarContent from '@material-ui/core/SnackbarContent';
// import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: ErrorIcon,
  warningF: ErrorIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const fontFam = 'Arial Regular';
const borderDim = '2px solid #C4C8C7';
const styles1 = theme => ({
  successIc: {
    color: '#68BB45',
  },
  warningIc: {
    color: '#DC1500',
  },
  errorIc: {
    color: '#DC1500',
  },
  infoIc: {
    color: '#0073A8',
  },
  success: {
    marginBottom: 20,
    marginTop: 10,
    fontSize: 22,
    color: '#404040',
    fontFamily: fontFam,
    backgroundColor: '#EEF1F2',
    outline: '#C4C8C7',
    border: borderDim,
  },
  warning: {
    marginBottom: 20,
    marginTop: 10,
    fontSize: 22,
    color: '#404040',
    fontFamily: fontFam,
    backgroundColor: '#EEF1F2',
    outline: '#C4C8C7',
    border: borderDim,
  },
  warningF: {
    marginBottom: 20,
    marginTop: 10,
    fontSize: 22,
    color: '#404040',
    fontFamily: fontFam,
    backgroundColor: '#EEF1F2',
    outline: '#C4C8C7',
    border: borderDim,
    message: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 22,
      maxWidth: '30em',
    },
  },
  info: {
    fontSize: 22,
    color: '#404040',
    fontFamily: fontFam,
    backgroundColor: '#EEF1F2',
    outline: '#C4C8C7',
    border: borderDim,
  },
  error: {
    marginBottom: 20,
    marginTop: 10,
    fontSize: 22,
    color: '#CD1500',
    fontFamily: fontFam,
    backgroundColor: '#FFFFFF',
    outline: '#CD1500',
    border: '1px solid #CD1500',
  },
  icon: {
    fontSize: 33,
    marginRight: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 22,
    maxWidth: '20em',
  },
});

export function InfoMessageBar(props) {
  const {
    classes,
    className,
    message,
    variant,
    width,
    icColor,
    ...other
  } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      aria-describedby="client-snackbar"
      className={classNames(classes[variant], className)}
      message={
        <span
          className={classes.message}
          id="client-snackbar"
          style={{ maxWidth: [width] }}
        >
          <Icon
            className={classNames(classes[icColor], classes.icon, className)}
          />
          {message}
        </span>
      }
      {...other}
    />
  );
}

InfoMessageBar.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  width: PropTypes.number,
  variant: PropTypes.oneOf(['success', 'warning', 'warningF', 'error', 'info'])
    .isRequired,
  icColor: PropTypes.oneOf(['successIc', 'warningIc', 'errorIc', 'infoIc'])
    .isRequired,
};

export default withStyles(styles1)(InfoMessageBar);
